//Global External Imports
import { useTranslation } from "react-i18next";
import React, { useEffect, useState, Fragment } from "react";

//Global Internal Imports
import apiRequest from "../../functions/api";
import { useMessage } from "../../context/message-context";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Formular from "../Formular/Formular";
import { useZulassung } from "../../context/zulassungs-context";
import { useParams } from "react-router-dom";
import { useSessionStorage } from "../../utils/hooks";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import {
  Autocomplete,
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { CheckBox, FilterList, Save } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";

function VMATabelleEinstellen(props) {
  const { standardTabelle, onSave, value, open, onOpenChange } = props;

  const { t } = useTranslation();
  const [eigeneTabelle, setEigeneTabelle] = useState([]);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openPortal = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  //PVX Kommunikation
  useEffect(() => {
    if (value) {
      setEigeneTabelle(value);
    }
  }, []);

  const onValueChange = (key, was, value) => {
    const zwis = eigeneTabelle;
    const obj = zwis.find((item) => item.key === key);
    if (obj) {
      obj[was] = value;
    }
    setEigeneTabelle([...zwis]); // Update the state with the modified array
  };
  const addLine = (key) => {
    setAnchorEl(null);
    var itemToAdd = {};
    const existingTable = eigeneTabelle || [];
    if (key.value === "ALLE") {
      itemToAdd = { bez: "Alle anderen", vierundzwanzigStunden: "0", achtStunden: "0", uebernachten: "0", key: "ALLE" };
    } else {
      itemToAdd = standardTabelle.find((e) => e.key === key.value);
    }
    if (itemToAdd) {
      existingTable.push(itemToAdd);
      setEigeneTabelle(existingTable);
    }
  };
  const removeLine = (key) => {
    setEigeneTabelle(eigeneTabelle.filter((e) => e.key !== key));
  };
  const handleCloseDialog = () => {
    onOpenChange(false);
  };
  const saveTabelle = (tabelle) => {
    onSave(tabelle);
    handleCloseDialog();
  };
  //Rückgabe
  return (
    <>
      {" "}
      <Dialog open={open} onClose={onOpenChange} maxWidth="xl">
        <DialogTitle id="alert-dialog-title">{"Individuelle Spesensätze einrichten"}</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 1000 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Land</TableCell>
                  <TableCell align="right">8 Stunden </TableCell>
                  <TableCell align="right">24 Stunden satz </TableCell>
                  <TableCell align="right">Übernachtung</TableCell> <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {!eigeneTabelle?.length > 0 ? (
                  <></>
                ) : (
                  eigeneTabelle?.map((row) => (
                    <TableRow key={row.key} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row.bez}
                      </TableCell>
                      <TableCell align="right">
                        <FormControlLabel
                          value="bottom"
                          control={
                            <Checkbox
                              checked={!(row.achtStunden === "SKIP")}
                              // onChange={(e) => onValueChange(row.key, "achtStunden", e.target.value)}
                              onChange={(e) => onValueChange(row.key, "achtStunden", e.target.checked ? "0" : "SKIP")}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                          label=""
                          labelPlacement="top"
                        />
                        <TextField
                          onChange={(e) => onValueChange(row.key, "achtStunden", e.target.value)}
                          disabled={row.achtStunden === "SKIP"}
                          value={row.achtStunden === "SKIP" ? "Nicht berücksichtigt" : row.achtStunden}
                        ></TextField>
                      </TableCell>
                      <TableCell align="right">
                        <FormControlLabel
                          value="bottom"
                          control={
                            <Checkbox
                              checked={!(row.vierundzwanzigStunden === "SKIP")}
                              // onChange={(e) => onValueChange(row.key, "achtStunden", e.target.value)}
                              onChange={(e) => onValueChange(row.key, "vierundzwanzigStunden", e.target.checked ? "0" : "SKIP")}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                          label=""
                          labelPlacement="top"
                        />
                        <TextField
                          disabled={row.vierundzwanzigStunden === "SKIP"}
                          onChange={(e) => onValueChange(row.key, "vierundzwanzigStunden", e.target.value)}
                          value={row.vierundzwanzigStunden === "SKIP" ? "Nicht berücksichtigt" : row.vierundzwanzigStunden}
                        ></TextField>
                      </TableCell>
                      <TableCell align="right">
                        <FormControlLabel
                          value="bottom"
                          control={
                            <Checkbox
                              checked={!(row.uebernachten === "SKIP")}
                              // onChange={(e) => onValueChange(row.key, "achtStunden", e.target.value)}
                              onChange={(e) => onValueChange(row.key, "uebernachten", e.target.checked ? "0" : "SKIP")}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                          label=""
                          labelPlacement="top"
                        />

                        <TextField
                          onChange={(e) => onValueChange(row.key, "uebernachten", e.target.value)}
                          disabled={row.uebernachten === "SKIP"}
                          value={row.uebernachten === "SKIP" ? "Nicht berücksichtigt" : row.uebernachten}
                        ></TextField>
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => removeLine(row.key)}>
                          <CloseIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell align="right">
                    <>
                      <Button onClick={openPortal} variant="contained" color="primary">
                        Individuelle Sätze hinzufügen
                      </Button>
                      <Popover
                        id="simple-popper"
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "center",
                        }}
                        style={{ width: "1000px", height: "300px" }} // add this line
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "center",
                        }}
                      >
                        <Card style={{ width: "700px", padding: "20px" }}>
                          <Autocomplete
                            noOptionsText={t("kein Eintrag gefunden")}
                            onChange={(event, newValue) => {
                              addLine(newValue);
                            }}
                            options={[{ label: "Alle Anderen", value: "ALLE" }, ...standardTabelle.map((land) => ({ label: land?.bez, value: land.key }))]}
                            // options={standardTabelle.map((land) => ({ label: land?.bez, value: land.key }))}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={t("Land auswählen")}
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            )}
                          />
                        </Card>
                      </Popover>
                    </>
                  </TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Abbrechen</Button>
          <Button onClick={() => saveTabelle(eigeneTabelle)} autoFocus>
            Speichern
          </Button>
        </DialogActions>
      </Dialog>
      {/* <Button fullWidth onClick={() => onSave(eigeneTabelle)} savevariant="contained" color="primary">
        Speichern
      </Button> */}
    </>
  );
}
export default VMATabelleEinstellen;
